import { PdfData } from "./types";

const SafetyEventsData: PdfData = {
  title: "Other Safety Events",
  description: {
    i18nKey: "safety_event_description",
    label:
      "Please report here other serious events or near miss events involving safety of the children",
  },
  fields: [
    {
      name: "eventDate",
      label: "Event date",
    },
    {
      name: "eventLocation",
      label: "Event location",
    },
    {
      name: "origin",
      label: "origin",
    },
    {
      name: "mistreatmentEvidence",
      label:
        "Is there any suspicion or evidence of abuse of one or more children? = child mistreatment",
    },
    {
      name: "area",
      label: "Area",
    },
    {
      name: "description",
      label: "Event Description (factual & taken care of elements)",
    },
    {
      name: "immediateConsequences",
      label: "The immediate consequences of the event",
    },
    {
      name: "immediateCorrectiveAction",
      label: "Immediate corrective actions",
    },
    {
      name: "insuranceBeenNotified",
      label: "Has the insurance claim been filed?",
    },
    {
      name: "localAuthorityBeenNotified",
      label: "Has the local authority been notified?",
    },
    {
      name: "supervisionRateRespected",
      label:
        "Was the supervision rate respected at the time of the accident in the reception area concerned?",
    },
    {
      name: "usualTeam",
      label: "Usual team in the reception area?",
    },
    {
      name: "professionalNames",
      label: "Name of all staff involved when the incident took place",
    },
    {
      name: "riskRelatedEvent",
      label: "Risks related to the event",
    },
    {
      name: "eventAvoidedSaferEquipment",
      label: "Could the event have been avoided with safer equipment?",
    },
    {
      name: "consequencesHad",
      label: "The consequences that the event could have had",
    },
    {
      name: "recurrence",
      label: "Recurrence",
    },
  ],
};

export default SafetyEventsData;
